// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ccfG","inner":"Footer_inner__1cIEH"};